import { useSwrNoAuth } from "../swr/useSwrNoAuth";

export const useFetchTableQrCodeImageUrl = (tableId: string) => {
  const { data: qrCodeImageUrl, error, isLoading } = useSwrNoAuth<string>(`table_stock/tables/${tableId}/qr-code/image-url/`)
  return { qrCodeImageUrl, isLoading, error };
};

